import { render, staticRenderFns } from "./yiWhite.vue?vue&type=template&id=5d346bbe&scoped=true&"
import script from "./yiWhite.vue?vue&type=script&lang=js&"
export * from "./yiWhite.vue?vue&type=script&lang=js&"
import style0 from "./yiWhite.vue?vue&type=style&index=0&id=5d346bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d346bbe",
  null
  
)

export default component.exports